import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdMail } from "react-icons/io";
import { FaPhone } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 sm:p-6 md:p-8">
      <footer className="bg-black w-full text-white px-6 sm:px-10 md:px-24 py-12 sm:py-16 rounded-3xl relative overflow-hidden">
        {/* Background Text */}
        <span
          className="absolute inset-0 flex justify-center items-end 
          text-[clamp(2rem,6vw,100px)] font-extrabold 
          text-white/5 tracking-wider leading-none 
          pointer-events-none select-none whitespace-nowrap pb-16 sm:pb-24"
        >
          TWIN STAR INDUSTRIES
        </span>

        <div className="relative w-full z-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 sm:gap-14 md:gap-20 pb-12 sm:pb-20">
          {/* Left Section */}
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl md:text-[24px] font-semibold">
              Do you like what you see?
            </h2>
            <p className="text-gray-400 text-base sm:text-[16px] max-w-sm">
              Let’s work together to turn your dream project into reality.
            </p>
            <button
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate("/contact");
              }}
              className="inline-flex text-base sm:text-[16px] font-medium items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
            >
              Let&apos;s Talk with Us →
            </button>
          </div>

          {/* Useful Links */}
          <div>
            <h3 className="font-semibold text-lg sm:text-[18px] mb-3 sm:mb-4">
              Useful Links
            </h3>
            <ul className="space-y-2 text-base sm:text-[16px] font-medium text-gray-400">
              <li>
                <a href="#projects" className="hover:text-white">
                  Our Products
                </a>
              </li>
              <li>
                <a href="/about" className="hover:text-white">
                  About Us
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-white">
                  News & Blogs
                </a>
              </li>
              <li>
                <a href="/team" className="hover:text-white">
                  Our Team
                </a>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="font-semibold text-lg sm:text-[18px] mb-3 sm:mb-4">
              Information
            </h3>
            <ul className="space-y-2 text-base sm:text-[16px] text-gray-400">
              <li>
                <a href="/contact" className="hover:text-white">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-white">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Get In Touch */}
          <div>
            <h3 className="font-semibold text-lg sm:text-[18px] mb-3 sm:mb-4">
              Get In Touch
            </h3>
            <p className="text-gray-400 mb-4 text-base sm:text-[16px]">
              Connect with us
            </p>
            <div className="flex gap-3">
              <a
                href="mailto:Twin81@rediffmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20"
              >
                <IoMdMail className="w-5 h-5" />
              </a>
              <a
                href="tel:9382232004"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20"
              >
                <FaPhone className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
          <div className="mt-10 border-t border-gray-600 pt-4 text-center text-sm text-gray-300 flex flex-col gap-1">
          <span>© 2026 Twin Star Industry. All Rights Reserved.</span>
          <span>
            Developed By{" "}
            <a
              href="https://crackdevelopers.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-red-400 font-semibold transition"
            >
              crackdevelopers.com
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
